var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownLightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13354 0.761134L5.41287 8.594e-09L3.06683 2.47233L0.72079 6.45465e-08L0.000111589 0.761134L3.06683 4L6.13354 0.761134Z",
    fill: "#64C1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownLightGreen);
export default __webpack_public_path__ + "static/media/chevron-down_light-green.e0554d313b2ff0598970cca249a177ae.svg";
export { ForwardRef as ReactComponent };